import React, { Component } from 'react';
import './Deals.css';
import {DealItem} from './DealItem'
import SimpleSlider from '../SimpleSlider/SimpleSlider';
import { Img } from '../UI/UI';
import { getImgUrl , limitText } from "../../Utility/Utility"


class Deals extends Component {
  
  constructor (props){
  	super(props);
  	this.image_url = getImgUrl();
  	
  	this.dealsSliderSettings = {
      	dots: true,
      	infinite: true,
      	cssEase: 'linear',
      	autoplay:false,
      	lazyLoad: "ondemand",
      	slidesToShow: (this.props.items != undefined  ) ? this.props.items : 3,
		slidesToScroll: 1,
		responsive: [
	        {
	          breakpoint: 1000,
	          settings: {
	            slidesToShow: 2,
	            slidesToScroll: 2
	          }
	        },
	        {
	          breakpoint: 600,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1
	          }
	        }
      	]
    };

  	  	this.deals = [
        
			// {
			// 	"title": "Ayelet Tours, Ltd.",
			// 	"link": "https://ayelet.com/holy-land-tours/",
			// 	"price": " $1,540",
			// 	"desc":"Holy Land - 7 or 10 nights including holy and historic sights,from Jerusalem to the Galilee!",
			// 	"logo":"/Deals/AyeletLogo_Blue_2017.jpg",
			// 	"book_now" : "BOOK NOW"
			// },
			// {
			// 	"title": "Maranatha Tours",
			// 	"desc": "Join Maranatha Tours on a 9 Day Best of Israel 'Return to Travel Special'. Your tour will depart from San Francisco to Tel Aviv on an all inclusive Summer Tour Priced at Winter Rates!",
			// 	"price": "$2,799",
			// 	"link": "https://www.maranathatours.com/tours?destination=israel",
			// 	"logo":"/Deals/MaranathaTours.jpg",
			// 	"book_now" : "BOOK NOW"
			// },
			// {
			// 	"title": "SITA World Tours",
			// 	"desc": "$200 off per couple on SITA's 7-day Israel Explorer tour. Book by February 28, 2002 for all departures in 2022.",
			// 	"price": "$2,280",
			// 	"link": "https://sitatours.com/vacation-destinations/middle-east/israel/israel-explorer/",
			// 	"logo":"/Deals/SITAWorldTours.jpg",
			// 	"book_now" : "BOOK NOW"
			// },
			// {
			// 	"title": "Ayelet Tours, Ltd.",
			// 	"link": "https://ayelet.com/ayelet-platinum/",
			// 	"price": " $3,400",
			// 	"desc":"Israel PLATINUM - Private touring with expert advice",
			// 	"logo":"/Deals/AyeletLogo_Blue_2017.jpg",
			// 	"book_now" : "BOOK NOW"
			// },
			// {
			// 	"title": "Globus family of brands",
			// 	"desc": "Just Say Yes to New Adventures with Globus. The Deal is On! Book by March 31, 2022 to save $300 per couple on select air inclusive 2022 Globus Europe vacations with United/Lufthansa/Air Canada",
			// 	"price": "$4,159",
			// 	"link": "https://www.globusjourneys.com/tour/israel-wonders-of-jordan/qce/?season=2022",
			// 	"logo":"/Deals/Globus.jpg",
			// 	"book_now" : "BOOK NOW"
			// },
			{
					"title": "Bell Wholesale Travel, Inc.",
					"link": "https://eur01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fbwti.com%2Fholy-land-tours.html&data=05%7C01%7CJillD%40goisrael.gov.il%7C094b0a8f1be6466c958608da296b0d60%7Ce5a1a45ba59f44db8fa1d979ba86371b%7C1%7C1%7C637867837031205225%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C1000%7C%7C%7C&sdata=kjCQDX5mZ8KyhOo5TvR3dr%2FscszUs%2Ff5bleloo6TJYk%3D&reserved=0",
					"price": " $1,487",
					"desc":"Guaranteed Departures",
					"logo":"/Deals/BellWholesaleTravel.jpg",
					"book_now" : "BOOK NOW"
			},
			{
				"title": "Festival International Travel",
				"link": "https://eur01.safelinks.protection.outlook.com/?url=https%3A%2F%2Ftoursfestival.com%2Flistados-busqueda.php%3Fpaises%3DISRAEL%26ciudades%3Dno%26nombre%3Dno%26dias%3DNaN_a_NaN%26salida%3Dno%26otroDestino%3Dno&data=04%7C01%7CDirector-LA%40goisrael.gov.il%7Cdfe2017c03b54da3a97408da11466a7d%7Ce5a1a45ba59f44db8fa1d979ba86371b%7C1%7C1%7C637841291390059094%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C1000&sdata=H%2FLIaJ6Wvuh4HlnKWSQvK11WR8Pby94vXM5at2Cnw0g%3D&reserved=0",
				"price": " 1,495$",
				"desc":"Viaje Tierra Santa 7 Noches",
				"logo":"/Deals/FestivalInternationalTravel.jpg",
				"book_now" : "BOOK NOW"
			},
			{
				"title": "Bell Wholesale Travel, Inc.",
				"link": "https://eur01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fbwti.com%2Fjoinatour.html&data=05%7C01%7CJillD%40goisrael.gov.il%7C094b0a8f1be6466c958608da296b0d60%7Ce5a1a45ba59f44db8fa1d979ba86371b%7C1%7C1%7C637867837031205225%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C1000%7C%7C%7C&sdata=dd9N8%2FRR%2BHKHddZ4rkoRBDI0D2Dq0JrVf3w5YSgH2oI%3D&reserved=0",
				"price": " $1,606",
				"desc":"Lead Your Own Tour in the Land of the Bible",
				"logo":"/Deals/BellWholesaleTravel.jpg",
				"book_now" : "BOOK NOW"
		    },
			{
				"title": "Pilgrim Tours",
				"link": "https://www.pilgrimtours.com/israel-tours/best-of-israel-10.html",
				"price": " $1,899",
				"desc":"Best of Israel 10 Day/ 8 Night. Our most popular Christian Tour to the Holy Land",
				"logo":"/Deals/PilgrimTours.jpg",
				"book_now" : "BOOK NOW"
		    },
			{
				"title": "America Israel Tours",
				"link": "https://eur01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fwww.americaisraeltours.com%2Fisrael-tours%2F&data=05%7C01%7CDirector-LA%40goisrael.gov.il%7C2836be6522f845bfb23408da26f522d2%7Ce5a1a45ba59f44db8fa1d979ba86371b%7C1%7C1%7C637865131554572574%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C2000%7C%7C%7C&sdata=zM5XdMZsrxnTQ4nKoT0EA4UNVbzI8owiEILV9bkcGhE%3D&reserved=0",
				"price": " $2,450",
				"desc":" 5-star deluxe tour leads you through the Holy Land, where you will visit the most important Biblical and historical sites, as well as modern Israel.",
				"logo":"/Deals/AmericaIsraelTours.jpg",
				"book_now" : "BOOK NOW"
		    },
			{
				"title": "Maranatha Tours",
				"link": "https://eur01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fwww.maranathatours.com%2Ftours%3Fdestination%3Disrael&data=04%7C01%7CDirector-LA%40goisrael.gov.il%7C6e161b143c314a4c4a3808d9aebb1189%7Ce5a1a45ba59f44db8fa1d979ba86371b%7C1%7C0%7C637732941475533981%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C2000&sdata=Iv4kOB7q0WFi9OliV0lQKW0gNYfhlQ79dNJ%2FZc8SRMs%3D&reserved=0",
				"price": " $2,799",
				"desc":"Tours on a 9 Day Best of Israel “Return to Travel Special. ",
				"logo":"/Deals/MaranathaTours.jpg",
				"book_now" : "BOOK NOW"
		    },
			{
				"title": "Bell Wholesale Travel, Inc.",
				"link": "https://eur01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fbwti.com%2Fjoinatour.html&data=05%7C01%7CJillD%40goisrael.gov.il%7C094b0a8f1be6466c958608da296b0d60%7Ce5a1a45ba59f44db8fa1d979ba86371b%7C1%7C1%7C637867837031205225%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C1000%7C%7C%7C&sdata=dd9N8%2FRR%2BHKHddZ4rkoRBDI0D2Dq0JrVf3w5YSgH2oI%3D&reserved=0",
				"price": " $3,342",
				"desc":"Join a Tour Led by a Local Pastor",
				"logo":"/Deals/BellWholesaleTravel.jpg",
				"book_now" : "BOOK NOW"
		    },
			{
				"title": "Inspiration Cruises & Tours",
				"link": "https://eur01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fwww.inspirationcruises.com%2Fisrael&data=04%7C01%7CDirector-LA%40goisrael.gov.il%7Cfa1db2cd93c240004a1d08da11a7a6d6%7Ce5a1a45ba59f44db8fa1d979ba86371b%7C1%7C0%7C637841709000303983%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C3000&sdata=NDddZoTSnB9BWBTk8pOffRVFMJy5qi4E0Jio0gQsD5c%3D&reserved=0",
				"price": " $3,998",
				"desc":"Join Your Favorite Christian Leader and See 40+ Sites in 9 Days",
				"logo":"/Deals/Inspiration.jpg",
				"book_now" : "BOOK NOW"
		    },
			{
				"title": "Isram Israel",
				"link": "https://isramisraelusa.com/packages/discover-holyland-private-car/",
				"price": " $5,700",
				"desc":"Discover the Holyland by Private Car ",
				"logo":"/Deals/IsramIsrael.jpg",
				"book_now" : "BOOK NOW"
		    },

			
	]

  }

  render() {

  	const dealsHtml = this.deals.map((o)=>{
  		return <DealItem 
		            key={ o.title } 
  					brand={ o.title } 
  					price={ o.price } 
  					brandImg={ o.logo } 
  					desc={ o.desc } 
  					bookNowLink={o.link}
  					descFontSize={ o.fontSize }
				/>
  	})
    return (
	      <div className="deals-wrapper">
        	<SimpleSlider settings={this.dealsSliderSettings}>
	           {dealsHtml}
          	</SimpleSlider>
	      </div>
    );
  }
}

export default Deals;



// WEBPACK FOOTER //
// ./src/Components/Deals/Deals.js